import { todayIso } from '@kanos/web-core';

/** The hours of a day to choose from, in the team's own time. */
export const HOURS = Array.from({ length: 24 }, (_, h) => ({
  id: String(h),
  label: `${String(h).padStart(2, '0')}:00 Uhr`,
}));

/** A day and an hour of the team's own time, as the API keeps it. */
export const isoOf = (day: string, hour: string) =>
  new Date(`${day}T${hour.padStart(2, '0')}:00:00`).toISOString();

/** A point in time as the day and hour to choose it by. */
export const dayAndHourOf = (iso: string) => {
  const at = new Date(iso);
  return { day: todayIso(at), hour: String(at.getHours()) };
};
